import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import cn from 'classnames';
export var ECGOverlay = function (_a) {
    var labels = _a.labels, elementId = _a.elementId, patientName = _a.patientName, isPrintQualityActive = _a.isPrintQualityActive;
    var _b = useState(0), overlayWidth = _b[0], setOverlayWidth = _b[1];
    var classes = {
        container: cn('e-flex e-bg-base-white e-gap-2', {
            'e-p-10': isPrintQualityActive,
            'e-p-2': !isPrintQualityActive,
        }),
        title: cn('e-font-semi-bold', {
            'e-text-4xl e-pb-4 e-pr-8 e-w-auto e-whitespace-nowrap': isPrintQualityActive,
            'e-text-xs e-w-48': !isPrintQualityActive,
        }),
        itemContainer: cn('e-flex e-flex-wrap e-justify-start w-full', {
            'e-gap-x-16 e-gap-y-6': isPrintQualityActive,
            'e-gap-2': !isPrintQualityActive,
        }),
        item: cn('e-gap-1 e-flex e-items-center', {
            'e-w-auto': isPrintQualityActive,
            'e-w-48 e-truncate': !isPrintQualityActive,
        }),
        label: cn('e-w-auto', {
            'e-text-3xl e-py-2': isPrintQualityActive,
            'e-text-2xs e-truncate': !isPrintQualityActive,
        }),
    };
    // Listen when one of the grid items resizes
    useEffect(function () {
        var currentGridItem = document.getElementsByClassName(elementId)[0];
        if (!currentGridItem)
            return;
        var itemObserver = new ResizeObserver(function () { return setOverlayWidth(currentGridItem.clientWidth); });
        itemObserver.observe(currentGridItem);
        return function () { return itemObserver.disconnect(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elementId]);
    var isFullEdenMediaQuery = overlayWidth >= 700;
    return (_jsxs("section", { "data-testid": "ecg-overlay-".concat(elementId), className: cn(classes.container, {
            'e-flex-row e-items-center': isFullEdenMediaQuery,
            'e-flex-col': !isFullEdenMediaQuery,
        }), children: [_jsx("h3", { className: classes.title, children: patientName }), _jsx("ul", { className: classes.itemContainer, children: labels.map(function (_a) {
                    var label = _a.label, value = _a.value;
                    if (!value)
                        return null;
                    return (_jsxs("li", { className: classes.item, children: [_jsx("span", { className: cn(classes.label, 'e-whitespace-nowrap e-font-medium e-text-neutral-300'), children: label }), _jsx("span", { className: cn(classes.label, 'e-font-semi-bold e-text-neutral-700'), children: value })] }, value));
                }) })] }));
};
//# sourceMappingURL=ECGOverlay.js.map